/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Input_1 = require("./Input");
var InputURL = /** @class */ (function (_super) {
    tslib_1.__extends(InputURL, _super);
    function InputURL() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputURL.prototype.render = function () {
        return React.createElement(Input_1.Input, tslib_1.__assign({}, this.props));
    };
    InputURL.propTypes = Input_1.Input.propTypes;
    InputURL.defaultProps = tslib_1.__assign({}, Input_1.Input.defaultProps, { type: "url" });
    return InputURL;
}(React.Component));
exports.InputURL = InputURL;